import React from 'react';
import type { ICompany } from './CompanyTag';

interface CompanyPercentageProps {
  company: ICompany;
}

/**
 * Shared component for displaying company symbol and percentage
 */
const CompanyPercentage: React.FC<CompanyPercentageProps> = ({ company }) => {
  // Handle undefined or null percentage
  const hasPercentage = company?.percentage !== undefined && company?.percentage !== null;
  
  if (!hasPercentage) {
    return (
      <div className="h-[24px] md:h-[28px] flex items-center py-1 px-2 rounded-[20px] border border-[#E5E5E5] bg-white">
        <span className="font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle text-[#1A1A1A]">{company?.symbol}</span>
      </div>
    );
  }

  const percentage = company.percentage ?? 0;
  const isValidPercentage = !Number.isNaN(percentage) && Number.isFinite(percentage);
  
  if (!isValidPercentage) {
    return (
      <div className="h-[24px] md:h-[28px] flex items-center py-1 px-2 rounded-[20px] border border-[#E5E5E5] bg-white">
        <span className="font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle text-[#1A1A1A]">{company?.symbol}</span>
      </div>
    );
  }

  const isPositive = percentage >= 0;
  const percentageDisplay = `${isPositive ? '+' : ''}${percentage.toFixed(2)}%`;

  return (
    <div className="h-[24px] md:h-[28px] flex items-center gap-[10px] py-1 px-2 rounded-[20px] border border-[#E5E5E5] bg-white">
      <span className="font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle text-[#1A1A1A]">
        {company?.symbol}
      </span>
      <span
        className={`font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle ${
          isPositive ? 'text-[#067161]' : 'text-red-500'
        }`}
      >
        {percentageDisplay}
      </span>
    </div>
  );
};

export default CompanyPercentage;

